import axios from "./axios";

export const getClienteOptionsIntervenciones = () =>
    axios.get("/allClienteOptions");
export const getTipoEventosOptionsIntervenciones = () =>
    axios.get("allTipoEventosOptions");
export const getPlantaOptionsIntervenciones = () =>
    axios.get("/allPlantaOptions");
export const getEquiposOptionsIntervenciones = () =>
    axios.get("/allEquipoOptions");

export const getPlantaByOptionsIntervenciones = (id: number) =>
    axios.get(`/allPlantaByClienteIdOptions/${id}`);
export const getEquipoByOptionsIntervenciones = (id: number) =>
    axios.get(`/allEquipoByClienteIdOption/${id}`);
export const getEquipoPlantaByOptionsIntervenciones = (id: number) =>
    axios.get(`/allEquipo/planta/${id}/option`);

